// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapComponent from './components/MapComponent';
import MissionView from './pages/MissionView'; // make sure this path is correct

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Default map page */}
        <Route path="/" element={<MapComponent />} />

        {/* Shared mission view */}
        <Route path="/m/:id" element={<MissionView />} />
      </Routes>
    </Router>
  );
};

export default App;
